import { useTranslation } from 'react-i18next';
import { usePriceGroup } from 'core/contexts/priceGroup';
import arrayMutators from 'final-form-arrays';
import { Form } from 'react-final-form';
import { FieldArray } from 'react-final-form-arrays';
import { Box, Grid2, Typography } from '@mui/material';
import Title from '../../../components/Title';
import ActionButtons from '../ActionButtons';
import QuantityRangeFields from 'modules/Pricing/components/QuantityRangeFields';

const QuantityRangesForm = () => {
    const { t } = useTranslation();
    const translate = (key) => t(`price_group_wizard.quantity_ranges_form.${key}`);
    const { quantityForm, handleUpdateQuantity, handleNext, handleBack, validateRanges } = usePriceGroup();

    const validateForm = ({ ranges = [] }) => {
        return validateRanges(ranges);
    };

    const handleSubmit = ({ ranges }) => {
        handleUpdateQuantity(ranges);
        handleNext();
    };

    return (
        <Form
            onSubmit={handleSubmit}
            mutators={{ ...arrayMutators }}
            initialValues={quantityForm}
            validate={validateForm}
            render={({ handleSubmit, values }) => {
                const ranges = values.ranges || [];
                const lastRange = ranges[ranges.length - 1] || {};
                const lastToEmpty = lastRange.quantityTo === '' || lastRange.quantityTo === undefined;

                return (
                    <form onSubmit={handleSubmit} noValidate style={{ width: '100%', maxWidth: '480px' }}>
                        <Box component="section">
                            <Title title={translate('title')} description={translate('description')} />

                            {/* Form */}
                            <Grid2 container width="100%" direction="column" justifyContent="flex-start" alignItems="flex-start" gap="8px" mt="24px">
                                <FieldArray name="ranges">{({ fields }) => <QuantityRangeFields fields={fields} lastToEmpty={lastToEmpty} canAdd canRemove />}</FieldArray>
                            </Grid2>

                            <Box mt={2}>
                                <Typography variant="caption" color="textSecondary">
                                    {translate('note')}
                                </Typography>
                            </Box>

                            <ActionButtons
                                handleSubmit={(e) => {
                                    return handleSubmit(e);
                                }}
                                handleBack={handleBack}
                            />
                        </Box>
                    </form>
                );
            }}
        />
    );
};

export default QuantityRangesForm;
